export const defaultState = {
  loading: false,
};

export const startLoading = state => ({
  ...state,
  loading: true,
});

export const stopLoading = state => ({
  ...state,
  loading: false,
});
